import React from 'react';

/* 의뢰구분(협회/비협회) 비주얼 배지 — 목록·필터·폼·상세 공용.
   SchedulePage 안에 있던 것을 컴포넌트로 뺐다 — PartnerViewModal 이 함께 쓰는데
   페이지에서 가져오면 순환 임포트가 된다(파트너 포털도 같은 위치에 별도 사본이 있다). */
export const REQUEST_TYPE_META: Record<string, { color: string; bg: string; border: string; icon: string }> = {
  '협회':   { color: '#7c3aed', bg: '#f5f3ff', border: '#c4b5fd', icon: '🏛️' },
  '비협회': { color: '#0d9488', bg: '#f0fdfa', border: '#99f6e4', icon: '🏢' },
};
export const RequestTypeBadge: React.FC<{ value?: string | null; size?: 'sm' | 'md' }> = ({ value, size = 'sm' }) => {
  const key = value === '협회' ? '협회' : '비협회';
  const m = REQUEST_TYPE_META[key];
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 3,
      padding: size === 'sm' ? '0 7px' : '2px 10px',
      borderRadius: 999,
      fontSize: size === 'sm' ? 11 : 12, fontWeight: 700,
      color: m.color, background: m.bg, border: `1px solid ${m.border}`,
      lineHeight: size === 'sm' ? '18px' : '20px', whiteSpace: 'nowrap',
    }}>
      <span style={{ fontSize: size === 'sm' ? 10 : 12, lineHeight: 1 }}>{m.icon}</span>
      {key}
    </span>
  );
};
